import {LanguageEnum} from 'types';

import logger from './logger';

export const isObjEmpty = (obj?: Record<any, any>) =>
  obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype;

export const removeQuotesFromString = (string: string) => {
  return string.replace(/['"]+/g, '');
};

export const getLocaleFromUrl = (): LanguageEnum => {
  if (typeof window === 'undefined') return LanguageEnum.RO;

  const [, localeFromUrl] = window?.location.pathname.split('/') ?? [];

  return localeFromUrl && [LanguageEnum.EN, LanguageEnum.RU, LanguageEnum.RO].includes(localeFromUrl as LanguageEnum)
    ? (localeFromUrl as LanguageEnum)
    : LanguageEnum.RO;
};

export const isProviderMcdonalds = (providerSlug: string) => providerSlug === 'mcdonalds';

const isTimestampGreaterThanXMins = (mins: number) => (timestamp: number) => {
  logger.addBreadcrumb('isTimestampGreaterThanXMins', {timestamp, newDate: new Date()});
  return !!(timestamp && new Date()?.getTime() - timestamp > mins * 60 * 1000);
};

export const isTimestampGreaterThan10Mins = isTimestampGreaterThanXMins(10);
export const isTimestampGreaterThan15Mins = isTimestampGreaterThanXMins(15);

export const minutesInMs = (mins: number) => mins * 60 * 1000;
export const fifteenMinutesInMs = minutesInMs(15);

export const getDeliveryTimeString = (avgDeliveryTime?: number) => {
  if (!avgDeliveryTime) return '';
  return `${avgDeliveryTime} -  ${avgDeliveryTime + 10}`;
};
